import { parsePhoneNumberFromString, AsYouType } from 'libphonenumber-js'

export const getAsYouTypeFormat = (payload) => {
  const { countryCode, phoneNumber } = payload
  const asYouType = new AsYouType(countryCode)
  return phoneNumber ? asYouType.input(phoneNumber) : null
}

export const getParsePhoneNumberFromString = ({ phoneNumber, countryCode }) => {
  const parsing = phoneNumber && countryCode ? parsePhoneNumberFromString(phoneNumber, countryCode) : null
  // console.debug(parsing)
  return {

    isValid: false,
    ...(phoneNumber && (phoneNumber !== '')
      ? { phoneNumber: phoneNumber }
      : null
    ),
    ...(parsing
      ? {
        countryCode: parsing.country, // use country code from rrsult, not the original one
        countryCallingCode: parsing.countryCallingCode,
        formattedNumber: parsing.number,
        nationalNumber: parsing.nationalNumber,
        isValid: parsing.isValid(),
        type: parsing.getType(),
        formatInternational: parsing.formatInternational(),
        formatNational: parsing.formatNational(),
        uri: parsing.getURI(),
        e164: parsing.format('E.164')
      }
      : null
    )
  }
}

export const fetchCountryCode = async () => {
  try {
    const response = await fetch('https://ip2c.org/s')
    const responseText = await response.text()
    const result = (responseText || '').toString()
    // console.debug(result)
    if (result && result[0] === '1') {
      return result.substr(2, 2);
    }

    return undefined;
  } catch (err) {
    throw new Error((err as string | undefined))
  }
}